import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { BcComponentsService, DetailBcLineinfos } from '../../bc-components.service';
import { Router } from '@angular/router';
import { NTHDestination, getStringByDest } from 'src/app/shared/constants/flag';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { StateService } from 'src/app/shared/services/state.service';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';


@Component({
  selector: 'app-bcligne-enveloppe-create-form',
  templateUrl: './bcligne-enveloppe-create-form.component.html',
  styleUrls: ['./bcligne-enveloppe-create-form.component.scss']
})
export class BcligneEnveloppeCreateFormComponent implements OnChanges, AfterViewChecked {
  @Input() bcLineRef: Observable<DetailBcLineinfos>;
  @Input() bc: BcModel;
  referentiel: DetailBcLineinfos = new DetailBcLineinfos();
  @Input() bcForm: UntypedFormGroup;
  bcLineFormArray: UntypedFormArray;
  bcLine: UntypedFormGroup;
  codeCa1: string;
  @Output() amountHTsEmit = new EventEmitter<any[]>();
  constructor(
              private readonly changeDetectorRef: ChangeDetectorRef,
              public router: Router,
              private bcComponentsService: BcComponentsService,
              private stateService: StateService,
              ) {     
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.bcForm) {
      this.bcLineFormArray = this.bcForm.get('bcLines') as UntypedFormArray;    

      if (this.bcLineFormArray.value.length > 0){
        this.bcLine = this.bcLineFormArray.at(0) as UntypedFormGroup | null;
        if (this.bcForm.get('codeCa1').value) {
          this.codeCa1 = this.bcForm.get('codeCa1').value;
          this.bcComponentsService.loadDestination(0, this.bcLine);
        }
      } else {
        this.bcLine = this.bcComponentsService.createBcLineEnveloppe(this.bcForm);
        this.bcLineFormArray.push(this.bcLine);
      }

      this.bcLineRef = this.bcComponentsService.getBcLineRef(0);

      this.bcLineRef.subscribe((ref: DetailBcLineinfos) => {
        if (this.referentiel.categories.length != ref.categories.length && ref.categories.length == 0)
        {
          this.bcComponentsService.getBcLineFormEvent(this.bcLine, 0, DefinitionTypeBC.BCEnveloppe);
        }
        this.referentiel = ref;
      });

      this.bcForm.get('codeCa1').valueChanges.subscribe(codeCa1 => {
        this.codeCa1 = codeCa1;
        this.bcLine.get('codeCa1').setValue(codeCa1);
        this.bcLineRef = this.bcComponentsService.getBcLineRef(0);
      });

      this.bcForm.get('libelleCa1').valueChanges.subscribe(libelleCa1 => {
        this.bcLine.get('libelleCa1').setValue(libelleCa1);
      });

      this.bcLine.get('ht').valueChanges.subscribe(ht => {
        this.bcLine.controls['pu'].setValue(1);
        this.bcLine.controls['qte'].setValue(ht);
        this.amountHTsEmit.emit(ht);
      });
    }
  }

  getString(dest: NTHDestination): string{
    return getStringByDest(dest);
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  displayErrors(): void {
    for (const bcline in this.bcLineFormArray.controls) {
      if (bcline) {
        this.bcLineFormArray.controls[bcline].markAsTouched();
      }
    }
  }
}
